module.exports = __webpack_public_path__ + "media/images/payments/verisign-ecf540b373d1b812a683933167ab28c0.svg";